export default __webpack_public_path__ + "static/media/one-oneguidance.1763a092.png";